import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatSliderModule } from '@angular/material/slider';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { I18NTranslateModule } from '@ebw-monorepo/i18n-translate';
import { MaterialModule } from '@ebw-monorepo/material';
import { SidebarHeaderComponent } from '@ebw-monorepo/ui';
import { UtilsModule } from '@ebw-monorepo/utils';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MtxGridModule } from '@ng-matero/extensions/grid';
import { TranslateService } from '@ngx-translate/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AngularSplitModule } from 'angular-split';
import { AsFooterComponent } from './components/as-footer/as-footer.component';
import { WorldLayerChangeComponent } from './components/controls/base-map-change/world-layer-change.component';
import { DXFMapControlComponent } from './components/controls/dxf-map-control/dxf-map-control.component';
import { FullScreenComponent } from './components/controls/full-screen/full-screen.component';
import { GoToPositionComponent } from './components/controls/go-to-position/go-to-position.component';
import { GoogleStreetViewControlComponent } from './components/controls/google-streetview-control/google-streetview-control.component';
import { InfoViewComponent } from './components/controls/info-view/info-view.component';
import { MapPreviewComponent } from './components/controls/map-preview/map-preview.component';
import { MapSearchComponent } from './components/controls/map-search/map-search.component';
import { PlotMapControlComponent } from './components/controls/plot-map-control/plot-map-control.component';
import { PrintMapControlComponent } from './components/controls/print-map-control/print-map-control.component';
import { ZoomInComponent } from './components/controls/zoom-in/zoom-in.component';
import { ZoomOutComponent } from './components/controls/zoom-out/zoom-out.component';
import { CustomButtonComponent } from './components/custom-button/custom-button.component';
import { DrawingToolComponent } from './components/drawing-tool/drawing-tool.component';
import { DXFMapComponent } from './components/dxf-map/dxf-map.component';
import { DynamicFormComponent } from './components/dynamic-form/dynamic-form.component';
import { EbwMapComponent } from './components/ebw-map/ebw-map.component';
import { ExportDialogComponent } from './components/export-dialog/export-dialog.component';
import { FeatureViewerDetailsComponent } from './components/feature-viewer/feature-viewer-details/feature-viewer-details.component';
import { FeatureViewerTreeComponent } from './components/feature-viewer/feature-viewer-tree/feature-viewer-tree.component';
import { GoogleStreetviewComponent } from './components/google-streetview/google-streetview.component';
import { LayerHistoryTimelineComponent } from './components/layer-history-timeline/layer-history-timeline.component';
import { MapComponent } from './components/map-component/map-component.component';
import { MapControlSpeedDialComponent } from './components/map-control-speed-dial/map-control-speed-dial.component';
import { AttachmentDialogComponent } from './components/map-table/attachment-dialog/attachment-dialog.component';
import { MapTableFeatureDetailComponent } from './components/map-table/map-table-feature-detail/map-table-feature-detail.component';
import { MapTableComponent } from './components/map-table/map-table.component';
import { OpacitySliderComponent } from './components/opacity-slider/opacity-slider.component';
import { OtdrTableComponent } from './components/otdr-table/otdr-table.component';
import { PlotMapSnackbarComponent } from './components/plot-map/plot-map-snackbar/plot-map-snackbar.component';
import { PlotMapComponent } from './components/plot-map/plot-map.component';
import { PrintMapComponent } from './components/print-map/print-map.component';
import { RankSelectorPercComponent } from './components/rank-selector-perc/rank-selector-perc.component';
import { RankSelectorComponent } from './components/rank-selector/rank-selector.component';
import { ReportDialogObjectViewerComponent } from './components/report-dialog/report-dialog-object-viewer/report-dialog-object-viewer.component';
import { ReportDialogComponent } from './components/report-dialog/report-dialog.component';
import { AnalisiSchiacciamentiComponent } from './components/sidebar/analisi-schiacciamenti/analisi-schiacciamenti.component';
import { BookmarksFormComponent } from './components/sidebar/bookmarks/bookmarks-form/bookmarks-form.component';
import { BookmarksComponent } from './components/sidebar/bookmarks/bookmarks.component';
import { CheckinAnalysisTableComponent } from './components/sidebar/checkin-analysis/checkin-analysis-table/checkin-analysis-table.component';
import { CheckinAnalysisComponent } from './components/sidebar/checkin-analysis/checkin-analysis.component';
import { ToOpenHistoryModalComponent } from './components/sidebar/checkin-analysis/to-open-history/to-open-history-modal.component';
import { CheckinOutTableComponent } from './components/sidebar/checkin-out/checkin-out-table/checkin-out-table.component';
import { CheckInOutComponent } from './components/sidebar/checkin-out/checkin-out.component';
import { ControlliCodiciPrelieviDialogComponent } from './components/sidebar/controlli/controlli-codici-prelievi-dialog/controlli-codici-prelievi-dialog.component';
import { ControlliCodiciSuperamentiDialogComponent } from './components/sidebar/controlli/controlli-codici-superamenti-dialog/controlli-codici-superamenti-dialog.component';
import { ControlliTemplateInfoDialogComponent } from './components/sidebar/controlli/controlli-template-info-dialog/controlli-template-info-dialog.component';
import { ControlliUploadSezioneComponent } from './components/sidebar/controlli/controlli-upload-sezione/controlli-upload-sezione.component';
import { ControlliComponent } from './components/sidebar/controlli/controlli.component';
import { RischioAnaliticoDetailComponent } from './components/sidebar/controlli/rischio-analitico/rischio-analitico-detail/rischio-analitico-detail.component';
import { RischioAnaliticoDistribuzioneChartComponent } from './components/sidebar/controlli/rischio-analitico/rischio-analitico-distribuzione-chart/rischio-analitico-distribuzione-chart.component';
import { RischioAnaliticoFiltriComponent } from './components/sidebar/controlli/rischio-analitico/rischio-analitico-filtri/rischio-analitico-filtri.component';
import { RischioAnaliticoHeatmapChartComponent } from './components/sidebar/controlli/rischio-analitico/rischio-analitico-heatmap-chart/rischio-analitico-heatmap-chart.component';
import { RischioAnaliticoLegendaDialogComponent } from './components/sidebar/controlli/rischio-analitico/rischio-analitico-legenda-dialog/rischio-analitico-legenda-dialog.component';
import { RischioAnaliticoRiepilogoComponent } from './components/sidebar/controlli/rischio-analitico/rischio-analitico-riepilogo/rischio-analitico-riepilogo.component';
import { RischioAnaliticoTrendChartComponent } from './components/sidebar/controlli/rischio-analitico/rischio-analitico-trend-chart/rischio-analitico-trend-chart.component';
import { RischioAnaliticoComponent } from './components/sidebar/controlli/rischio-analitico/rischio-analitico.component';
import { DynamicLayersComponent } from './components/sidebar/dynamic-layers/dynamic-layers.component';
import { FormLayersModalComponent } from './components/sidebar/dynamic-layers/form-layers-modal/form-layers-modal.component';
import { SingleLayerFormComponent } from './components/sidebar/dynamic-layers/form-layers-modal/single-layer-form/single-layer-form.component';
import { DraggableLegendComponent } from './components/sidebar/ebw-layers-configurator/draggable-legend/draggable-legend.component';
import { EbwLayersConfiguratorComponent } from './components/sidebar/ebw-layers-configurator/ebw-layers-configurator.component';
import { FiberEditComponent } from './components/sidebar/fiber-joints/fiber-edit/fiber-edit.component';
import { FiberHistoryModalComponent } from './components/sidebar/fiber-joints/fiber-history-modal/fiber-history-modal.component';
import { FiberJointsComponent } from './components/sidebar/fiber-joints/fiber-joints.component';
import { FiberTableComponent } from './components/sidebar/fiber-joints/fiber-table/fiber-table.component';
import { RaccordiCavoAttachmentsComponent } from './components/sidebar/fiber-joints/raccordi-cavo-attachments/raccordi-cavo-attachments.component';
import { RaccordiCavoEditComponent } from './components/sidebar/fiber-joints/raccordi-cavo-edit/raccordi-cavo-edit.component';
import { RaccordiCavoHomeComponent } from './components/sidebar/fiber-joints/raccordi-cavo-home/raccordi-cavo-home.component';
import { RaccordiCavoTableComponent } from './components/sidebar/fiber-joints/raccordi-cavo-table/raccordi-cavo-table.component';
import { DefaultOtdrFormComponent } from './components/sidebar/otdr/forms/default-otdr-form/default-otdr-form.component';
import { FastwebOtdrFormComponent } from './components/sidebar/otdr/forms/fastweb-otdr-form/fastweb-otdr-form.component';
import { OtdrComponent } from './components/sidebar/otdr/otdr.component';
import { AttachActionComponent } from './components/sidebar/psa/attach-action/attach-action.component';
import { AttachEventComponent } from './components/sidebar/psa/attach-event/attach-event.component';
import { CheckListComponent } from './components/sidebar/psa/check-list/check-list.component';
import { DetailActionComponent } from './components/sidebar/psa/detail-action/detail-action.component';
import { DetailEventComponent } from './components/sidebar/psa/detail-event/detail-event.component';
import { DetailNodeComponent } from './components/sidebar/psa/detail-node/detail-node.component';
import { EliminazioneBloccataDialogComponent } from './components/sidebar/psa/eliminazione-bloccata-dialog/eliminazione-bloccata-dialog.component';
import { FilterAndTransformPipe } from './components/sidebar/psa/filter-psa-pipe';
import { PsaCreateInterconnectionComponent } from './components/sidebar/psa/psa-create-interconnection/psa-create-interconnection.component';
import { PsaDuplicateComponent } from './components/sidebar/psa/psa-duplicate/psa-duplicate.component';
import { PsaElementDetailComponent } from './components/sidebar/psa/psa-element-detail/psa-element-detail.component';
import { PsaFeatureTreeElement } from './components/sidebar/psa/psa-feature-tree-element/psa-feature-tree-element';
import { FilesystemBreadcrumbComponent } from './components/sidebar/psa/psa-filesystem/components/filesystem-breadcrumb/filesystem-breadcrumb.component';
import { FileSystemFooterComponent } from './components/sidebar/psa/psa-filesystem/components/filesystem-footer/filesystem-footer.component';
import { FileSystemHeaderComponent } from './components/sidebar/psa/psa-filesystem/components/filesystem-header/filesystem-header.component';
import { FilesystemSearchComponent } from './components/sidebar/psa/psa-filesystem/components/filesystem-search/filesystem-search.component';
import { FilesystemSplitterComponent } from './components/sidebar/psa/psa-filesystem/components/filesystem-splitter/filesystem-splitter.component';
import { FilesystemToolbarComponent } from './components/sidebar/psa/psa-filesystem/components/filesystem-toolbar/filesystem-toolbar.component';
import { FilesystemTreeNodeComponent } from './components/sidebar/psa/psa-filesystem/components/filesystem-tree-node/filesystem-tree-node.component';
import { FilesystemTreeComponent } from './components/sidebar/psa/psa-filesystem/components/filesystem-tree/filesystem-tree.component';
import { ModalNewFolderComponent } from './components/sidebar/psa/psa-filesystem/components/modal-new-folder/modal-new-folder.component';
import { DropZoneDirective } from './components/sidebar/psa/psa-filesystem/directives/drop-zone.directive';
import { PsaFileSystemComponent } from './components/sidebar/psa/psa-filesystem/psa-filesystem.component';
import { PsaObjectViewerComponent } from './components/sidebar/psa/psa-viewer/psa-object-viewer.component';
import { PsaComponent } from './components/sidebar/psa/psa.component';
import { RelEntityEventoAzioneComponent } from './components/sidebar/psa/rel-entity-evento-azione/rel-entity-evento-azione.component';
import { RiskMatrixComponent } from './components/sidebar/psa/risk-matrix/risk-matrix.component';
import { UpdateEventProbabilitiesComponent } from './components/sidebar/psa/update-event-probabilities/update-event-probabilities.component';
import { UpdateRelActionValueComponent } from './components/sidebar/psa/update-rel-action-value/update-rel-action-value.component';
import { QueryFormComponent } from './components/sidebar/query/query-form/query-form.component';
import { QueryTabsComponent } from './components/sidebar/query/query-tabs/query-tabs.component';
import { QueryComponent } from './components/sidebar/query/query.component';
import { LayerStyleFormComponent } from './components/sidebar/shape-configurator/add-layer-style-form/add-layer-style-form.component';
import { ShapeLayerFormComponent } from './components/sidebar/shape-configurator/add-shape-layer-form/add-shape-layer-form.component';
import { ShapeLayersConfiguratorComponent } from './components/sidebar/shape-configurator/shape-layers-configurator.component';
import { ShowLayerStylesComponent } from './components/sidebar/shape-configurator/show-layer-styles/show-layer-styles.component';
import { TracingComponent } from './components/sidebar/tracing/tracing.component';
import { AnteaCredentialsDialogComponent } from './components/sidebar/trasmissione-antea/antea-credentials-dialog/antea-credentials-dialog.component';
import { TrasmissioneAnteaSezioneComponent } from './components/sidebar/trasmissione-antea/trasmissione-antea-sezione/trasmissione-antea-sezione.component';
import { TrasmissioneAnteaComponent } from './components/sidebar/trasmissione-antea/trasmissione-antea.component';
import { ValveComponent } from './components/sidebar/valve/valve.component';
import { TreeComponent } from './components/tree/tree.component';
import { MapRoutingModule } from './map-routing.module';
import { CoordsStringPipe } from './pipe/coords.pipe';
import { FilterPipe } from './pipe/filter.pipe';
import { NormalizePipe } from './pipe/normalize.pipe';
import { ReplacePipe } from './pipe/replace.pipe';
import { UnderscoreToSpacePipe } from './pipe/underscore-to-space.pipe';
import { UnitaMisuraPipe } from './pipe/unita-misura.pipe';
import { UuidPipe } from './pipe/uuid.pipe';
import { MatPaginatorIntlService } from './services/custom.mat-paginator.service';

const directives = [DropZoneDirective];
@NgModule({
  declarations: [
    EbwMapComponent,
    MapComponent,
    WorldLayerChangeComponent,
    MapPreviewComponent,
    InfoViewComponent,
    MapSearchComponent,
    ZoomInComponent,
    ZoomOutComponent,
    FullScreenComponent,
    GoToPositionComponent,
    GoogleStreetviewComponent,
    GoogleStreetViewControlComponent,
    EbwLayersConfiguratorComponent,
    DrawingToolComponent,
    DynamicLayersComponent,
    FormLayersModalComponent,
    PrintMapComponent,
    PrintMapControlComponent,
    PlotMapComponent,
    PlotMapControlComponent,
    PlotMapSnackbarComponent,
    DXFMapControlComponent,
    DXFMapComponent,
    CustomButtonComponent,
    ReplacePipe,
    MapControlSpeedDialComponent,
    ShapeLayersConfiguratorComponent,
    ShapeLayerFormComponent,
    BookmarksComponent,
    BookmarksFormComponent,
    QueryComponent,
    QueryFormComponent,
    QueryTabsComponent,
    MapTableComponent,
    OtdrTableComponent,
    DraggableLegendComponent,
    ValveComponent,
    UnderscoreToSpacePipe,
    UnitaMisuraPipe,
    OtdrComponent,
    PsaComponent,
    ControlliComponent,
    ControlliUploadSezioneComponent,
    ControlliCodiciPrelieviDialogComponent,
    ControlliCodiciSuperamentiDialogComponent,
    ControlliTemplateInfoDialogComponent,
    TrasmissioneAnteaComponent,
    AnteaCredentialsDialogComponent,
    TrasmissioneAnteaSezioneComponent,
    RischioAnaliticoComponent,
    RischioAnaliticoFiltriComponent,
    RischioAnaliticoRiepilogoComponent,
    RischioAnaliticoDetailComponent,
    RischioAnaliticoLegendaDialogComponent,
    RischioAnaliticoTrendChartComponent,
    RischioAnaliticoDistribuzioneChartComponent,
    RischioAnaliticoHeatmapChartComponent,
    PsaDuplicateComponent,
    PsaCreateInterconnectionComponent,
    CheckListComponent,
    RiskMatrixComponent,
    DefaultOtdrFormComponent,
    FastwebOtdrFormComponent,
    AnalisiSchiacciamentiComponent,
    AsFooterComponent,
    FilterPipe,
    OpacitySliderComponent,
    ReportDialogComponent,
    ReportDialogObjectViewerComponent,
    TreeComponent,
    AttachmentDialogComponent,
    NormalizePipe,
    CoordsStringPipe,
    SingleLayerFormComponent,
    CheckInOutComponent,
    CheckinOutTableComponent,
    LayerStyleFormComponent,
    ShowLayerStylesComponent,
    UuidPipe,
    FeatureViewerTreeComponent,
    FeatureViewerDetailsComponent,
    MapTableFeatureDetailComponent,
    DynamicFormComponent,
    PsaObjectViewerComponent,
    RelEntityEventoAzioneComponent,
    PsaFeatureTreeElement,
    PsaElementDetailComponent,
    DetailEventComponent,
    EliminazioneBloccataDialogComponent,
    DetailNodeComponent,
    DetailActionComponent,
    AttachActionComponent,
    AttachEventComponent,
    RankSelectorComponent,
    RankSelectorPercComponent,
    UpdateEventProbabilitiesComponent,
    UpdateRelActionValueComponent,
    PsaFileSystemComponent,
    FileSystemHeaderComponent,
    FileSystemFooterComponent,
    FilesystemSearchComponent,
    FilesystemBreadcrumbComponent,
    FilesystemToolbarComponent,
    FilesystemSplitterComponent,
    FilesystemTreeComponent,
    FilesystemTreeNodeComponent,
    ModalNewFolderComponent,
    TracingComponent,
    ExportDialogComponent,
    // AppButtonComponent,
    // directives
    ...directives,
    LayerHistoryTimelineComponent,
    CheckinAnalysisComponent,
    CheckinAnalysisTableComponent,
    ToOpenHistoryModalComponent,
    FiberJointsComponent,
    RaccordiCavoTableComponent,
    RaccordiCavoEditComponent,
    RaccordiCavoHomeComponent,
    FiberTableComponent,
    FiberEditComponent,
    FiberHistoryModalComponent,
    RaccordiCavoAttachmentsComponent
  ],
  imports: [
    MapRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    GoogleMapsModule,
    FontAwesomeModule,
    FormsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    MaterialModule,
    I18NTranslateModule,
    MtxGridModule,
    MatSliderModule,
    FormsModule,
    MatSliderModule,
    FilterAndTransformPipe,
    AngularSplitModule,
    UtilsModule,
    NgxChartsModule,
    // standalone
    SidebarHeaderComponent
  ],

  exports: [
    MapComponent,
    MapTableComponent,
    MapRoutingModule,
    FeatureViewerTreeComponent,
    FeatureViewerDetailsComponent,
    OtdrTableComponent,
    CheckinOutTableComponent
  ],
  providers: [
    DatePipe,
    //https://stackoverflow.com/questions/46869616/how-to-use-matpaginatorintl
    {
      provide: MatPaginatorIntl,
      useFactory: (translate) => {
        const service = new MatPaginatorIntlService();
        service.injectTranslateService(translate);
        return service;
      },
      deps: [TranslateService]
    },
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: {
        disableTooltipInteractivity: true // <-- Should do the trick
      }
    }
  ]
})
export class MapModule {}
